import {  useState } from "react";
import { Observer } from "mobx-react";

import { useStores } from "../../store";

import CompanyBasedInnterview from "./CompanyBasedInnterview";

import Previous from "./Previous";

export default function Interview() {
  const {  PopupStore } = useStores();
  const [search, setsearch] = useState();

  return (
    <Observer>
      {() => (
        <>
          {PopupStore.companyBasedInterview && (
            <CompanyBasedInnterview
              popUpInitialValue={PopupStore.companyBasedInterview}
              handlePopup={() => {
                PopupStore.setCompanyBasedInterview(false);
              }}
            />
          )}
          <div className="w-full border-t-2">
            <div className="px-4 md:px-8 lg:px-12">
              <div className="flex justify-between items-center py-5">
                <h1 className="text-lg md:text-xl font-bold">
                  Recent interviews
                </h1>
              </div>
              <div className="min-h-[40vh]">
                <Previous filterTopic={search} />
              </div>
            </div>
          </div>
        </>
      )}
    </Observer>
  );
}
